module.exports = __webpack_public_path__ + "img/ENVI.eee6ec4f.jpg";